import { SparklesIcon } from 'lucide-react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { createPath } from 'react-router'
import { toast } from 'sonner'
import { useNewVersion } from '@/lib/app-version'
import { router } from './router'

/**
 * Once a new build is deployed: a quiet, dismissible toast offers a refresh, and the next move to another
 * page loads that page in full, so the new version arrives without an error and without losing a form.
 */
export function NewVersionPrompt() {
  const { t } = useTranslation()
  const available = useNewVersion()

  useEffect(() => {
    if (!available) return
    toast(t('update.available'), {
      id: 'new-version',
      description: t('update.availableHint'),
      icon: <SparklesIcon className="size-4" />,
      duration: Number.POSITIVE_INFINITY,
      action: { label: t('update.reload'), onClick: () => window.location.reload() },
    })
    return router.subscribe((state) => {
      const next = state.navigation.location
      if (state.navigation.state === 'loading' && next && next.pathname !== state.location.pathname) {
        window.location.assign(createPath(next))
      }
    })
  }, [available, t])

  return null
}
